import React from 'react'
import { SubSection } from '../../../interfaces/Publication';

interface BtnDataSheetProps{
    subSection: SubSection
}

const BtnDataSheet = ({subSection} : BtnDataSheetProps) => {
    return (
        <div className="header__actions">
        <button className="btn btn-alt-primary"  onClick={ () =>{ window.open(`${subSection.urlFicha}`, "_blank") } }>
            <span className="btn__icon"
            ><i className="icon icon-vpro-sec-tech-sheet"></i
            ></span>
            <span
            className="btn__label"
            data-hint="Ver ficha ténica"
            >Ver ficha técnica</span
            >
        </button>
        </div>
        )
}


export default BtnDataSheet